import { createSvgElement } from '@ardoq/dom-utils';
import { IconName } from '@ardoq/icons';

const SPRITE_VIEWBOX = '0 0 24 24';

type SpriteIconAttributes = {
  /** Center x position. */
  cx: number;
  /** Center y position. */
  cy: number;
  size: number;
  color?: string;
};

const spriteIconElement = (
  iconName: IconName,
  { cx, cy, size, color }: SpriteIconAttributes
) => {
  const svg = createSvgElement('svg', {
    'pointer-events': 'none',
    x: `${cx - size / 2}`,
    y: `${cy - size / 2}`,
    width: `${size}`,
    height: `${size}`,
    viewBox: SPRITE_VIEWBOX,
    ...(color ? { color } : {}),
  });
  const use = createSvgElement('use');
  use.setAttributeNS(
    'http://www.w3.org/1999/xlink',
    'xlink:href',
    `#${iconName}`
  );
  svg.appendChild(use);
  return svg;
};

export { spriteIconElement };
